<template>
  <div
    class="px-5 w-full max-w-full flex flex-row flex-nowrap items-start overflow-x-auto"
    v-bind="containerProps"
  >
    <div v-bind="wrapperProps" class="gap-4">
      <slot v-for="item in list" :key="getKey(item.data)" :item="item">
        {{ item.index }}
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts" generic="T extends Record<string, unknown>">
import { useVirtualList } from "@vueuse/core";
import { computed } from "vue";

const props = defineProps<{
  items: T[];
  getKey: (item: T) => string;
  itemWidth: number;
}>();

const { list, containerProps, wrapperProps } = useVirtualList(
  computed(() => props.items),
  { itemWidth: props.itemWidth, overscan: 5 },
);
</script>
